/* eslint-disable @angular-eslint/no-outputs-metadata-property */
/* eslint-disable @angular-eslint/component-selector */
/* eslint-disable @angular-eslint/no-inputs-metadata-property */
/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging */
import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter } from '@angular/core';

import { BaseProxyComponent } from '../lib/base.proxy';
import { ProxyWebComponent } from './../lib/utils';

import { DcrSelect, DcrSelectOption } from '@diekeure/dcr-components';

export declare interface DcrSelectComponent extends DcrSelect {
  valueChange: EventEmitter<CustomEvent<string | string[]>>;
}

@ProxyWebComponent({ methods: ['select', 'selectItem', 'selectIndex', 'reset', 'clearSelections'] })
@Component({
  selector: `
    dcr-select[formControl],
    dcr-select[formControlName],
    dcr-select[ngModel]
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: [
    'value',
    'disabled',
    'required',
    'placeholder',
    'multiple',
    'quick',
    'label',
    'supportingText',
    'leadingIcon',
    'trailingIcon',
    'clearable',
    'displayText',
    'menuPositioning',
    'clampMenuWidth',
    'typeaheadDelay',
    'menuAlign',
    'validationMessage',
    'invalid',
    'selectedIndex',
  ],
  outputs: ['valueChange'],
})
export class DcrSelectComponent extends BaseProxyComponent {}

export declare interface DcrSelectOptionComponent extends DcrSelectOption {
  valueChange: EventEmitter<CustomEvent<string | string[]>>;
}

@ProxyWebComponent()
@Component({
  selector: 'dcr-select-option',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: ['value'],
})
export class DcrSelectOptionComponent extends BaseProxyComponent implements AfterViewInit  {

  override ngAfterViewInit() {
    return;
  }
}
